import { NumberQuestionProps } from '../../types';
import { NumberInput } from '../components/number-input';
import { NumberInputUnits } from '../components/number-input-units'
import { Controller, useFormContext } from 'react-hook-form';

export const NumberQuestion = ({ question }: NumberQuestionProps) => {
  const { control, clearErrors } = useFormContext();

  const min = question.validations?.min as number;
  const max = question.validations?.max as number;

  return (
    <Controller
      control={control}
      name={question.slug}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        const stringValue = value != null ? value.toString() : '';

        const handleChange = (stringValue: string) => {
          if (stringValue.trim() === '') {
            // If empty, set to undefined (for optional fields) or let validation handle it
            onChange('');
          } else {
            const numValue = parseInt(stringValue, 10);
            if (!isNaN(numValue)) {
              onChange(numValue);
            }
          }
          // Clear any existing error for this field when user types
          clearErrors(question.slug);
        };
        const units = question.units !== undefined && typeof question.units === 'string' ? question.units : null;


        if(units) {
          return (
            <NumberInputUnits
            value={stringValue}
            onChange={handleChange}
            placeholder={question.placeholder?.toString()}
            error={error?.message}
            required={question.required}
            min={min}
            max={max}
            units={units}
          />
          )
        } else {
        return (
          <NumberInput
            value={stringValue}
            onChange={handleChange}
            placeholder={question.placeholder?.toString()}
            error={error?.message}
            required={question.required}
            min={min}
            max={max}
          />
        );
        }
      }}
    />
  );
};
